import {createAction, props} from '@ngrx/store';
import {Taxonomy} from './taxonomy.reducer';
import {CreateUpdateTaxonomy} from './taxonomy-facade.service';
import {TaxonomyFilterModel} from './taxonomy-filters/taxonomy-filters.component';

export const loadTaxonomies = createAction(
  '[Taxonomy] Load taxonomies'
);
export const loadTaxonomiesByFilter = createAction(
  '[Taxonomy] Load taxonomies by filter',
  props<{ filter: TaxonomyFilterModel }>()
);

export const refreshTaxonomies = createAction(
  '[Taxonomy] Refresh loaded taxonomies',
);

export const loadAllTaxonomiesSuccess = createAction(
  '[Taxonomy] Taxonomies loaded',
  props<{ data: Taxonomy[] }>()
);
export const loadFilteredTaxonomiesSuccess = createAction(
  '[Taxonomy] Filtered Taxonomies loaded',
  props<{ data: Taxonomy[] }>()
);

export const createTaxonomy = createAction(
  '[Taxonomy] Create taxonomy',
  props<{ model: CreateUpdateTaxonomy }>()
);

export const createTaxonomySuccess = createAction(
  '[Taxonomy] Taxonomy created',
  props<{ data: Taxonomy }>()
);

export const updateTaxonomy = createAction(
  '[Taxonomy] Update taxonomy',
  props<{ model: CreateUpdateTaxonomy, id: number }>()
);

export const updateTaxonomySuccess = createAction(
  '[Taxonomy] Taxonomy updated',
  props<{ data: Taxonomy }>()
);

export const deleteTaxonomy = createAction(
  '[Taxonomy] Delete taxonomy',
  props<{ id: number }>()
);

export const deleteTaxonomySuccess = createAction(
  '[Taxonomy] Taxonomy deleted'
);
